import { MedicalTest } from './medical-test.model';
import { Drug } from './drug.model';
import { CartQuantityItem } from './cart-quantity.model';

export interface Order {
  id?: number;
  user_id?: number;
  order_number?: number;
  telephone?: number;
  location?: string;
  executed_at?: string[];
  created_at?: string;
  status?: string;
  description?: string;
  note?: string;
  availability?: string;
  medical_tests?: MedicalTest[];
  quantity?: number[]
  medical_consultation?: boolean;
  drugs?: Drug[];
  selected_quantity_type_ids?: number[]
}
  